import { all, takeLatest, put, select, call } from 'redux-saga/effects';
import { logBiEvent } from '@wix/da-shared-react/pkg/biLogger/redux/saga';
import { BiData, SignupScreenClickContinueBiEvent } from '@wix/da-bi/pkg/events';
import {
  joinWithEmail,
  setJoinMode,
  errorDisplayed,
  attemptSubmit2 as attemptSubmit,
} from '../actions/join';
import { getJoinState } from '../selectors/join';
import JoinState from '../types/join';

function* handleJoinWithEmail(action: ReturnType<typeof joinWithEmail>) {
  const joinState: JoinState = yield select(getJoinState);
  if (joinState.emailError || joinState.passwordError) {
    const errorMessages: string[] = [];
    joinState.passwordError && errorMessages.push(`password ${joinState.passwordError}`);
    joinState.emailError && errorMessages.push(`email ${joinState.emailError}`);
    // send event info to be logged by BI
    yield put(errorDisplayed(errorMessages.join(';')));
    return;
  }
  yield put(setJoinMode('email'));
  yield call(
    logBiEvent,
    BiData<SignupScreenClickContinueBiEvent>({
      evid: 238,
      page_number: 1,
    })
  );
}

function* handleAttemptSubmit(action: ReturnType<typeof attemptSubmit>) {
  const joinState: JoinState = yield select(getJoinState);

  if (joinState.usernameError || joinState.dobError) {
    const errorMessages: string[] = [];
    joinState.usernameError && errorMessages.push(`username ${joinState.usernameError}`);
    joinState.dobError && errorMessages.push(`dob ${joinState.dobError}`);
    // send event info to be logged by BI
    yield put(errorDisplayed(errorMessages.join(';')));
  }
}

export default function* joinSaga() {
  yield all([takeLatest(joinWithEmail, handleJoinWithEmail)]);
  yield all([takeLatest(attemptSubmit, handleAttemptSubmit)]);
}
